import React, { useContext } from "react";
import { ThemeContext } from "../../../contexts/theme-context";

const GitGraph = () => {
    const { theme } = useContext(ThemeContext);
  return (
    <>
      <div className="skills" style={{ backgroundColor: theme.secondary }}>
        <div className="skillsHeader">
          <h2 style={{ color: theme.primary }}>My Git contribution(live)</h2>
        </div>
        <a href="https://github.com/HannanShehzad" rel="noreferrer" target="_blank" style={{width:"100%"}}>
        <img
          src="https://ghchart.rshah.org/HannanShehzad"
          alt="GitHub Green Squares"
          style={{width:"100%"}}
        /></a>
      </div>
    </>
  );
};

export default GitGraph;
